import { $t } from "@/locales";
const errorCodeMap = {
  12020004: () => $t(`errorCode['{0} not found.']`, [$t(`errorCode['Tier charge plan']`)]),
  12011016: () => $t(`errorCode['Dynamic QR Code not active.']`),
  12011017: () => $t(`errorCode['Dynamic QR Code not enable.']`),
  12011018: () => $t(`errorCode['Access Denied.']`),
  12001043: () => $t(`errorCode['This door status changed. Please try again.']`),
  12001049: () => $t(`errorCode['Operation Failed. Please try again.']`),
  12001051: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['UID']`)]),
  12001052: () => $t(`errorCode['File format error.']`),
  12001057: () => $t(`errorCode['{0} not found.']`, [$t(`errorCode['Tier charge plan']`)]),
  12001058: () =>
    $t(`errorCode['{0} not found.']`, [$t(`errorCode['Feature billing charge plan new']`)]),
  12001059: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  12001060: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  12001061: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  12001062: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  12001064: () => $t(`errorCode['You are trying too often, please try again in 5 minutes']`),
  12001066: () => $t(`errorCode['the device is not in the office']`),
  12001069: () => $t(`errorCode['A maximum of 1000 data items can be imported']`),
  13021042: () => $t(`errorCode['The image is not a front view.']`),
  13021043: () => $t(`errorCode['A mask was detected.']`),
  13021044: () => $t(`errorCode['The image resolution is too low.']`),
  13021045: () => $t(`errorCode['No face was detected.']`),
  13021046: () => $t(`errorCode['The file size is too large.']`),
  13021047: () => $t(`errorCode['The face in the image is too large.']`),
  13021048: () => $t(`errorCode['The face in the image is too small.']`),
  13021049: () => $t(`errorCode['Multiple faces detected.']`),
  13021050: () => $t(`errorCode['The face is not clear enough.']`),
  13021051: () => $t(`errorCode['File format error.']`),
  13021052: () => $t(`errorCode['Face detection failed.']`),
  11131015: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['PIN']`)]),
  11131016: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['RF card']`)]),
  11131021: () => $t(`errorCode['Personnel is required.']`),
  11131022: () =>
    $t(`errorCode['The data has been updated. Please refresh the page and try again.']`),
  11131024: () =>
    $t(`errorCode['The data has been updated. Please refresh the page and try again.']`),
  11131032: () => $t(`errorCode['Failed to add. This user already has 5 license plates.']`),
  11131033: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['License Plate']`)]),
  11131036: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['UHF Card']`)]),
  11131047: () =>
    $t(`errorCode['This license plate is blocklisted and cannot be registered as a vehicle.']`),
  11131065: () => $t(`errorCode['Operation failed!']`),
  11001012: () => $t(`errorCode['Failed to get data.']`),
  11001013: () =>
    $t(`errorCode['The data has been updated. Please refresh the page and try again.']`),
  11451058: () => $t(`errorCode['Add temp key failed, please try it again']`),
  11451078: () => $t(`errorCode['Operation failed!']`),
  11341014: () => $t(`errorCode['Building name too long.']`),
  11341016: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11350026: () =>
    $t(
      `errorCode['You cannot select an option with fewer users than the current project members.']`
    ),
  11350027: () =>
    $t(`errorCode['{0} not found.']`, [$t(`errorCode['Feature billing gradient charge plan']`)]),
  11350028: () =>
    $t(`errorCode['{0} not found.']`, [$t(`errorCode['Feature billing charge plan new']`)]),
  11350044: () =>
    $t(`errorCode['You can only import a file at a time in the current parking lot.']`),
  11350045: () =>
    $t(`errorCode['Please remove the sensor device(s) before disabling this feature.']`),
  11370030: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11370031: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11011006: () => $t(`errorCode['Operation failed!']`),
  11011008: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Email']`)]),
  11011010: () => $t(`errorCode['Operation failed!']`),
  11011012: () => $t(`errorCode['Operation failed!']`),
  11011017: () => $t(`errorCode['Operation failed!']`),
  11011018: () => $t(`errorCode['Operation failed!']`),
  11011022: () => $t(`errorCode["the lock can\'t bind this community"]`),
  11011029: () => $t(`errorCode['Failed to get data.']`),
  11250003: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11250007: () => $t(`errorCode['No log to be exported.']`),
  11250009: () =>
    $t(`errorCode['Too large data! Please first export the data before %s first,thanks.']`),
  11250010: () => $t(`errorCode['No permission to export logs of this type.']`),
  11191005: () => $t(`errorCode['MAC address not in the MAC library.']`),
  11191006: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['MAC']`)]),
  11191007: () => $t(`errorCode['MAC address not in the MAC library.']`),
  11191008: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['MAC']`)]),
  11191009: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['MAC']`)]),
  11191010: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['MAC']`)]),
  11191011: () => $t(`errorCode['MAC address not in the MAC library.']`),
  11191012: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['MAC']`)]),
  11191013: () => $t(`errorCode['This MAC address is redirected on RPS.']`),
  11191014: () => $t(`errorCode['Operation failed!']`),
  11490014: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Email']`)]),
  11490022: () =>
    $t(
      `errorCode['Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.']`
    ),
  11490025: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['User Name or Password']`)]),
  11490026: () => $t(`errorCode['You cannot link to the currently logged in account.']`),
  11490027: () => $t(`errorCode['You cannot link an account that already link other accounts.']`),
  11490028: () => $t(`errorCode['You can only link up to 5 sites.']`),
  11490029: () =>
    $t(
      `errorCode['You cannot link multiple property manager accounts under the same installer account.']`
    ),
  11490033: () => $t(`errorCode['Please enable PM App first.']`),
  11490039: () =>
    $t(
      `errorCode['You can only import one file at a time. Please wait for the current import to finish.']`
    ),
  11141030: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11101008: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Email']`)]),
  11101009: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Mobile number']`)]),
  11101016: () => $t(`errorCode["Mobile Number doesn\'t exist."]`),
  11101017: () => $t(`errorCode["This Email doesn\'t exist."]`),
  11101022: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['ID']`)]),
  11101026: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11181025: () => $t(`errorCode['Operation failed!']`),
  11231008: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Timetable name']`)]),
  11231009: () => $t(`errorCode['Deleting failed. The timetable is used by a shift.']`),
  11231010: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Shift name']`)]),
  11231011: () => $t(`errorCode['Deleting failed. The shift is in use.']`),
  11231017: () => $t(`errorCode['Valid time conflicts with an existing schedule.']`),
  11231023: () => $t(`errorCode['Deleting failed. The leave type is in use.']`),
  11231029: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Attendance Log']`)]),
  11231033: () =>
    $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Attendance Point Name']`)]),
  11231034: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Leave type']`)]),
  11231035: () => $t(`errorCode['Operation failed!']`),
  11231036: () => $t(`errorCode['Operation failed!']`),
  11231037: () => $t(`errorCode['Operation failed!']`),
  11231044: () =>
    $t(`errorCode['The amount of exported data is too large. Please export it in batches.']`),
  11231045: () => $t(`errorCode['Operation failed!']`),
  11231048: () => $t(`errorCode['Failed to get data.']`),
  11231058: () => $t(`errorCode['']`),
  11231060: () =>
    $t(`errorCode['Operation failed! Daily limit of 15 records exceeded for this user.']`),
  11120002: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['The building name']`)]),
  11120006: () => $t(`errorCode['Failed to get data.']`),
  11120008: () => $t(`errorCode['Please delete devices under this building.']`),
  11120010: () => $t(`errorCode['Operation failed!']`),
  11121012: () => $t(`errorCode['Building name too long.']`),
  11031006: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Company name']`)]),
  11031013: () => $t(`errorCode['Operation failed!']`),
  11031014: () => $t(`errorCode['Operation failed!']`),
  11031018: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Floor']`)]),
  11031021: () => $t(`errorCode['Operation failed!']`),
  11031039: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11460015: () => $t(`errorCode['The custom quantity limit has been exceeded!']`),
  11161015: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Delivery name']`)]),
  11161023: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11070025: () => $t(`errorCode['Failed to get data.']`),
  11070041: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['MAC']`)]),
  11070043: () => $t(`errorCode['Failed to get data.']`),
  11070052: () => $t(`errorCode['Failed to get data.']`),
  11070054: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Controlled Relay']`)]),
  11070055: () =>
    $t(`errorCode['Invalid {0}.']`, [
      $t(`errorCode['selection, The same reader cannot be set for both entry and exit']`)
    ]),
  11070061: () => $t(`errorCode['door input cannot be selection duplicated.']`),
  11070074: () =>
    $t(`errorCode['This timeblock overlaps with an existing one. Please adjust it.']`),
  11070077: () =>
    $t(`errorCode['This time span overlaps with an existing one. Please adjust it.']`),
  11070078: () =>
    $t(
      `errorCode['This one time runs overlap with an existing one time runs effective time. Please adjust it.']`
    ),
  11070079: () => $t(`errorCode['Please enter a value between 1 and 9999']`),
  11070085: () => $t(`errorCode['Please select which input your door sensor is connected to.']`),
  11070088: () => $t(`errorCode['The device is not in the office']`),
  11070090: () => $t(`errorCode['The device is already assigned.']`),
  11070091: () => $t(`errorCode['The device cannot be assigned to any user.']`),
  11070105: () => $t(`errorCode['Elevator not configured in company access floor.']`),
  11070109: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  1147008: () => $t(`errorCode['The name specified is already in use.']`),
  11041002: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Group name']`)]),
  11041006: () => $t(`errorCode['Failed to get data.']`),
  11041020: () => $t(`errorCode['Operation failed!']`),
  11041033: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11150016: () => $t(`errorCode['Failed to get data.']`),
  11061008: () => $t(`errorCode['Failed to get data.']`),
  11061009: () => $t(`errorCode['Failed to get data.']`),
  11061010: () => $t(`errorCode['Failed to get data.']`),
  11061012: () => $t(`errorCode['Failed to get data.']`),
  11061013: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11061015: () => $t(`errorCode['Failed to get data.']`),
  11290005: () => $t(`errorCode['Failed to get data.']`),
  11290006: () => $t(`errorCode['Failed to get data.']`),
  11290008: () => $t(`errorCode['Please set the perimeter door group first.']`),
  11290009: () => $t(`errorCode['Failed to get data.']`),
  11290010: () => $t(`errorCode['Operation failed!']`),
  11291017: () => $t(`errorCode['Failed to get data.']`),
  11291019: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11051006: () => $t(`errorCode['Failed to get data.']`),
  11051008: () => $t(`errorCode['Failed to get data.']`),
  11051010: () => $t(`errorCode['Failed to get data.']`),
  11051016: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Email']`)]),
  11051017: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Phone number']`)]),
  11051023: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['ID']`)]),
  11051024: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Verification Code']`)]),
  11051032: () => $t(`errorCode['Failed to get data.']`),
  11051034: () => $t(`errorCode['Failed to get data.']`),
  11051036: () => $t(`errorCode['Operation failed!']`),
  11051047: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11090002: () => $t(`errorCode['Operation failed!']`),
  11090012: () => $t(`errorCode['The office does not exist.']`),
  11090020: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Office name']`)]),
  11090022: () => $t(`errorCode['The office does not exist.']`),
  11090025: () =>
    $t(`errorCode['You can only import one template at a time in the current site.']`),
  11090026: () =>
    $t(`errorCode['You can only import one template at a time in the current site.']`),
  11090035: () => $t(`errorCode['Operation failed!']`),
  11090036: () => $t(`errorCode['']`),
  11090037: () => $t(`errorCode['']`),
  11090038: () => $t(`errorCode['Operation failed!']`),
  11090039: () => $t(`errorCode['Operation failed!']`),
  11171002: () => $t(`errorCode['Operation failed!']`),
  11171007: () => $t(`errorCode['The Temp Key does not exist.']`),
  11171014: () => $t(`errorCode['The office does not exist.']`),
  11171017: () => $t(`errorCode['Operation failed!']`),
  11171018: () => $t(`errorCode['Operation failed!']`),
  11301005: () =>
    $t(
      `errorCode['Please check if there is any unpaid orders, if not, please contact your service provider.']`
    ),
  11301011: () => $t(`errorCode['Operation failed!']`),
  11301012: () => $t(`errorCode['Operation failed!']`),
  11301013: () =>
    $t(`errorCode['Please ensure that all doors in the project are activated at the same time.']`),
  11301018: () =>
    $t(
      `errorCode['Please check if there is any unpaid orders, if not, please contact your service provider.']`
    ),
  11301019: () =>
    $t(`errorCode['Please ensure that all doors in the project are renewed at the same time.']`),
  11280007: () => $t(`errorCode['{0} already exists.']`, [$t(`errorCode['Parking Lot Name']`)]),
  11280008: () => $t(`errorCode['Operation failed!']`),
  11280009: () => $t(`errorCode['Operation failed!']`),
  11280013: () => $t(`errorCode['Operation failed!']`),
  11280015: () => $t(`errorCode['Failed to get data.']`),
  11280016: () =>
    $t(`errorCode['The amount of exported data is too large. Please export it in batches.']`),
  11280018: () => $t(`errorCode['Operation failed!']`),
  11280065: () => $t(`errorCode['The exit time cannot be earlier than the entry time.']`),
  11281074: () =>
    $t(
      `errorCode['This license plate is already registered to a resident and cannot be added to the blocklist.']`
    ),
  11281076: () => $t(`errorCode['Exit time cannot be later than the current time.']`),
  11280081: () => $t(`errorCode['The license plate is already in the blocklist.']`),
  11201003: () =>
    $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['identity information! Please login again']`)]),
  11201009: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11201010: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11201011: () => $t(`errorCode['Operation failed!']`),
  11201015: () => $t(`errorCode['Operation failed!']`),
  11201016: () => $t(`errorCode['Operation failed!']`),
  11201017: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11201018: () =>
    $t(`errorCode['You do not have the necessary permissions to perform this operation.']`),
  11201021: () => $t(`errorCode['Operation failed!']`),
  11201023: () =>
    $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['identity information! Please login again']`)]),
  11211005: () => $t(`errorCode['Failed to get data.']`),
  11211007: () => $t(`errorCode['Operation failed!']`),
  11211008: () => $t(`errorCode['Operation failed!']`),
  11211009: () => $t(`errorCode['Failed to get data.']`),
  11211011: () => $t(`errorCode['Failed to get data.']`),
  11211012: () => $t(`errorCode['Failed to get data.']`),
  11211019: () => $t(`errorCode['Same account cannot login in different ins.']`),
  11211022: () => $t(`errorCode['Operation failed!']`),
  11321001: () => $t(`errorCode['invalid account or password']`),
  11321021: () => $t(`errorCode['QR code not exist']`),
  11480003: () => $t(`errorCode['Add temp key failed, please try it again']`),
  11221008: () => $t(`errorCode['Failed to get data.']`),
  11221010: () => $t(`errorCode['Failed to get data.']`),
  11221011: () => $t(`errorCode['This lock has already been added to another apartment.']`),
  11221012: () => $t(`errorCode['This lock has already been added to the apartment.']`),
  11221017: () => $t(`errorCode['Failed to get data.']`),
  11221040: () => $t(`errorCode['Unlock failed. Permission denied by user.']`),
  11021067: () => $t(`errorCode['QR code not exist']`),
  11021069: () => $t(`errorCode['The temp key has expired.']`),
  11021070: () => $t(`errorCode['Add temp key failed, please try it again']`),
  11021098: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11021099: (data: Record<string, any>) =>
    $t(
      `errorCode['A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.']`,
      [data["limit"]]
    ),
  11330009: () => $t(`errorCode['fail to get data']`),
  11271004: () => $t(`errorCode['Account already linked to another user.']`),
  11271005: () => $t(`errorCode['Failed to get data.']`),
  11081004: () => $t(`errorCode['Operation failed!']`),
  11081005: () => $t(`errorCode['Failed to get data.']`),
  11081016: () => $t(`errorCode['Password Incorrect.']`),
  11081021: () => $t(`errorCode['Please try again 24 hours later.']`),
  11081023: () => $t(`errorCode['You are trying too often, please try again in 5 minutes.']`),
  11081024: () => $t(`errorCode['Invalid {0}.']`, [$t(`errorCode['Code']`)]),
  11081025: () => $t(`errorCode['You are trying too often, please try again in 5 minutes.']`),
  11241007: () => $t(`errorCode['Operation failed!']`)
};
export default errorCodeMap;
